import React, { useState } from 'react';
import { Loader } from './Loader';
import { atlasId } from './layerTool';

enum Status {
  LOADING,
  SUCCESS,
  ERROR,
}

export const Atlas: React.FC<{ atlasUrl: string }> = ({ atlasUrl }) => {
  const [status, setStatus] = useState<Status>(Status.LOADING);
  return (
    <>
      {status !== Status.SUCCESS && (
        <div className="gen-layers-atlas-status">
          <Loader
            text={status === Status.LOADING ? 'Loading image' : 'Image has not been loaded'}
            loading={status === Status.LOADING}
          />
        </div>
      )}

      <svg className="gen-layers-atlas" width="0" height="0">
        <defs>
          <image
            id={atlasId}
            href={atlasUrl}
            onLoad={() => setStatus(Status.SUCCESS)}
            onError={() => setStatus(Status.ERROR)}
          />
        </defs>
      </svg>
    </>
  );
};
